import { css } from '@emotion/react';

import { useMemo, useState } from 'react';

import ChartHeader from 'components/charts/ChartHeader';
import BarChartV2 from 'components/charts/chartJS/BarChart';
import Legend from 'components/charts/chartJS/CustomChartLegend';
import { Divider } from 'components/charts/styled/Chart.styled';
import EnumSelect from 'components/field/EnumSelect';
import Card from 'components/global/Card';
import WidgetPageContainer from 'components/global/WidgetPageContainer';
import WidgetWrapper from 'components/global/WidgetWrapper';
import { FilterAction, FilterType } from 'components/list/DynamicListFilterUtils';

import useFetchAndParseOnView from 'hooks/useFetchAndParseOnView';

import { ENUMS, REPORT } from 'services/consts';

import { colorCombinations } from 'utils/colors';

import OverviewCharts from './OverviewCharts';
import * as S from './OverviewCharts.styled';
import PendingShipments from './PendingShipments';

const Overview = () => {
	return (
		<WidgetPageContainer>
			<WidgetWrapper widgetId={'analysis.overview'}>
				<OverviewCharts />
				<TotalPendingByDC />
			</WidgetWrapper>
			<WidgetWrapper widgetId={'analysis.pendingShipments'}>
				<Divider />
				<ChartHeader title="pendingShipments" showDivider={false} />
				<PendingShipments />
			</WidgetWrapper>
		</WidgetPageContainer>
	);
};

const TotalPendingByDC = () => {
	const [filter, setFilter] = useState({
		key: 'delayType',
		action: FilterAction.is,
		filterType: FilterType.enum
	});

	const body = useMemo(() => ({ ...filter }), [filter]);

	const parseData = ({ data }) => {
		const labels = data?.map((item) => item.deliveryCompanyName ?? '-');
		const datasets = ['greenCount', 'orangeCount', 'redCount'].map((key, idx) => ({
			data: data?.map((item) => item[key]),
			backgroundColor: colorCombinations[15 - idx].color,
			borderColor: colorCombinations[15 - idx].color
		}));
		return { labels, datasets };
	};

	const { ref, data, loading } = useFetchAndParseOnView({
		url: REPORT.DELIVERY_COMPANY.GET_AGGREGATOR_AGING_DC_ANALYSIS_CLIENT,
		body,
		parseData
	});

	return (
		<Card ref={ref}>
			<div>
				<ChartHeader
					title={'totalPendingByDC'}
					titleTooltip={'totalPendingByDCTooltip'}
					filter={
						<EnumSelect
							enumName={ENUMS.DELAY_TYPE}
							value={filter.value || []}
							setValue={(value) =>
								setFilter({
									...filter,
									value
								})
							}
							multipleSelection
							placeholder="delayType"
							css={css`
								min-width: 20rem;
								max-width: 40rem;
							`}
						/>
					}
				/>
				<BarChartV2
					data={data}
					loading={loading}
					xTitle={'deliveryCompanies'}
					yTitle={'orders'}
					aspectRatio={3}
				/>
				<S.LegendWrapper>
					{data && data.labels.length > 0 && (
						<Legend
							showAmount={false}
							data={{ labels: ['low', 'medium', 'high'] }}
							customColors={[
								colorCombinations[colorCombinations.length - 1],
								colorCombinations[colorCombinations.length - 2],
								colorCombinations[colorCombinations.length - 3]
							]}
							placeItems="horizontal"
						/>
					)}
				</S.LegendWrapper>
			</div>
		</Card>
	);
};

export default Overview;
